import { render } from "./CrecimientoView.vue?vue&type=template&id=d2bc9c22"
import script from "./CrecimientoView.vue?vue&type=script&lang=js"
export * from "./CrecimientoView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__